import { jsx as t } from "react/jsx-runtime";
import { forwardRef as r } from "react";
import { TextLinkCaret as e } from "@vds-core/buttons";
var o = r(function (r, o) {
  return t(e, Object.assign({}, r, {
    textLinkCaretRef: o
  }));
});
export { o as default };